import '../scss/style.scss'

import { accordion } from './modules/accordion'
import { tabs } from './modules/tabs'
import { overlayMenu } from './modules/overlay-menu'
import { pdfLinks } from './modules/pdf-links'
import { dropdown } from './modules/dropdown'
import { popup } from './modules/popup'
import { mainMenuExtraMarkup } from './modules/main-menu-extra-markup'
import { tabNavigation } from './modules/tab-navigation'
import { scrollSnapMenu } from './modules/scroll-snap-menu'
import { locationMap } from './modules/location-map'
import { searchPopup } from './modules/search-popup'
import { megaMenu } from './modules/mega-menu'

mainMenuExtraMarkup()

overlayMenu()

dropdown()

pdfLinks()

accordion()

tabs()

popup()

tabNavigation()

scrollSnapMenu()

locationMap()

searchPopup()

megaMenu()
